export class Acesso {
    constructor(
        public contratoId: string,
        public usuarioId: string,
        public perfis: Array<any>,
    ) { }
}